module.exports = __webpack_public_path__ + "static/media/lobby-carousel-chevron-right.4810a901.svg";